import React from 'react';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  itemsPerPage: number;
  onPageChange: (page: number) => void;
  onItemsPerPageChange: (itemsPerPage: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  totalItems,
  itemsPerPage,
  onPageChange,
  onItemsPerPageChange
}) => {
  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-3 mt-4 p-3 sm:p-4 border-t border-gray-200">
      <div className="flex items-center space-x-2">
        <button
          onClick={() => onPageChange(Math.max(1, currentPage - 1))}
          disabled={currentPage <= 1}
          className="p-2 border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <span className="text-sm">←</span>
        </button>
        <span className="text-sm text-gray-600 px-2">{currentPage} / {totalPages}</span>
        <button
          onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
          disabled={currentPage >= totalPages}
          className="p-2 border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <span className="text-sm">→</span>
        </button>
      </div>

      <div className="text-sm text-gray-600 order-first sm:order-none">
        <span>Total: </span>{totalItems}
      </div>

      <div className="flex items-center space-x-2 sm:space-x-4">
        {/* <span className="text-xs sm:text-sm text-gray-500 mr-2">Per page:</span> */}
        {[10, 25, 50].map((size) => (
          <button
            key={size}
            onClick={() => onItemsPerPageChange(size)}
            className={`hidden sm:inline text-xs sm:text-sm px-2 py-1 rounded transition-colors ${itemsPerPage === size
              ? 'bg-blue-100 text-blue-600 font-medium'
              : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
              }`}
          >
            {size}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Pagination;
